import { useEffect } from 'react'

import { getQueryParamsFromHash, parsePermittedQueryParams } from '@domain-group/javascript-utils'

import { useNumericParams } from '@domain-group/react-hooks'

import { generateUrls } from '@hooks/useCampaignQuote'

const useEditQuoteRedirect = () => {
  const { campaignId } = useNumericParams()
  const { quote_id }: { quote_id?: string } = parsePermittedQueryParams(getQueryParamsFromHash(), ['quote_id'])

  const campaignQuote = {
    campaign_id: campaignId,
    id: quote_id,
  }

  useEffect(() => {
    if (quote_id){
      // @ts-expect-error TS2345
      const { campaignEditQuoteUrl } = generateUrls(campaignQuote)
      window.location.hash = campaignEditQuoteUrl
    }
  }, [quote_id])
}

export default useEditQuoteRedirect
